import { Checkbox } from 'antd';
import AntCheckbox from './styles/checkbox.style';

export const IsoCheckbox = AntCheckbox(Checkbox);
export const IsoCheckboxGroup = Checkbox.Group;
